import React, { useEffect, useState }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Swal from 'sweetalert2'
import { useFormik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import MultiSelectDropdown from '../../Common/MultiSelectDropdown'
import { Autocomplete, TextField, MenuItem } from "@mui/material";

const validationSchema = yup.object({
    name: yup.string('Enter your name').required('Name is required'),
    teamId: yup.object().required('Organization is required'),
    competencies: yup.array().min(1, 'At least one competency is required')
});
export const AddTemplate = ({type, show, setShow, getList, editId, setEditId, ...rest}) => { 
    const [competencies, setCompetencies] = useState([]);
    const [selectedCompetencies, setSelectedCompetencies] = useState([]);
    const [selectedUsersLoaded, setSelectedUsersLoaded] = useState(false);
    const [teams, setTeams] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState(null);

    const handleClose = () => setShow(false);

    const getTeams = async () => {
        let teamList = [];
        await axios.get(`/api/teams`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                teamList = result.data;
                setTeams(result.data)
            }
        })
        return teamList;
    }

    const initialValues = {
        id: editId,
        name: '',
        teamId: null,
        competencies: []
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values); 
        }
    });

    useEffect(() => {
        const teamsPromise = getTeams()
        if(editId > 0){
            setSelectedCompetencies([]);
            axios.get(`api/singleSurvey?id=${editId}`).then(async res => {
                if(res.data.success){
                    formik.setFieldValue('id', res.data.data.id)
                    formik.setFieldValue('name', res.data.data.name)

                    // Survey doesn't store an organization, so derive it from its competencies
                    const teamList = await teamsPromise;
                    const surveyTeamId = res.data.data.survey_competencies.find(item => item.competency?.teamId)?.competency.teamId;
                    const team = teamList.find(t => t.id === surveyTeamId) || null;
                    formik.setFieldValue('teamId', team)
                    setSelectedTeam(team)

                    // const formattedCompetenciesArray = [];
                    // const surveyCompetencies = res.data.data.survey_competencies;
                    // for (let i = 0; i < surveyCompetencies.length; i++) {
                    //     const item = surveyCompetencies[i];
                    //     formattedCompetenciesArray.push({ id: item.competency.id, name: item.competency.name });
                    // }

                    // console.log("formattedCompetenciesArray",formattedCompetenciesArray)
                    const formattedCompetenciesArray = res.data.data.survey_competencies.map(item => {
                        return { id: item.competency.id, name: item.competency.name };
                    });
                    setSelectedCompetencies(formattedCompetenciesArray)
                    formik.setFieldValue('competencies', formattedCompetenciesArray)                   
                }
            })
        }
        else{
            setSelectedCompetencies([])
            setSelectedTeam(null)
            setCompetencies([])
            formik.resetForm();
        }
        
    },[show]);

    useEffect(() => {
        if(selectedTeam?.id){
            getCompetencies(selectedTeam.id)
        }
    }, [selectedTeam])

    useEffect(() => {
        setSelectedUsersLoaded(false);
        if (selectedCompetencies.length > 0) {
            formik.setFieldValue('competencies', selectedCompetencies)
            setSelectedUsersLoaded(true);
        }
    }, [selectedCompetencies])

    const getCompetencies = async (id) => {
        let apiUrl = "/api/competencies?status=1&orgId="+id;

        axios.get(apiUrl).then(function (response) {
            let result = response.data;
            if (result.success) {
                setCompetencies(result.data);
            } else {
                // Handle error or set isError state if needed.
            }
        });
    };

    const normalizeString = (value) => {
        if (!value) return '';
        return value.trim().replace(/\s+/g, ' ');
    };

    const handleSubmit = (values) =>{
        const cleanedValues = {
            ...values,
            name : normalizeString(values.name)
        }
        if(editId > 0){
            axios.put(`api/surveys/update`, cleanedValues).then(res => {
                setShow(false);   
                if(res.data.success){                 
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        getList();                        
                    })
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                // console.log(error.response.data)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }
        else{
            axios.post(`api/surveys/create`, cleanedValues).then(res => {
                setShow(false);
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        formik.resetForm();
                        getList();
                        
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false);
                // console.log(error.response.data)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }        
    }

    const handlePopupClose = () => {
        formik.resetForm();
        handleClose()
    }

    const handleTeamChange = (e, value) => {
        // console.log(value)
        if(value && value.id){
            formik.setFieldValue('teamId', value)
            setSelectedTeam(value)
        }
        else{
            formik.setFieldValue('teamId', null)
            setSelectedTeam(null)
        }
        
    }

    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>{type} Template</Modal.Title>
            </Modal.Header>
                <form onSubmit={formik.handleSubmit}>
                    <Modal.Body> 
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-email">Template Name</label>
                            <div className="input-group input-group-merge">
                                <input type="text" className="form-control" id="basic-icon-default-firstname" placeholder="Template Name" aria-label="Competency Name" aria-describedby="basic-icon-default-fullname2"
                                name="name"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur} 
                                value={formik.values.name} />
                            </div>
                            {formik.touched.name && formik.errors.name && (
                                <div className="text-danger">{formik.errors.name}</div>
                            )}
                        </div>
                        <div className="mb-3">
                            <label className="form-label" htmlFor="basic-icon-default-phone">Organization</label>   
                            <Autocomplete
                                id="teamId"
                                sx={{ width: 'auto' }}
                                size='small'
                                options={teams}
                                getOptionLabel={(option) => option.name}
                                onChange={handleTeamChange}
                                value={formik.values.teamId || null }
                                renderInput={(params) => <TextField {...params} label={"Select Organization"} />}
                            />
                            {formik.touched.teamId && formik.errors.teamId && (
                                <div className="text-danger">{formik.errors.teamId}</div>
                            )}                                          
                        </div>
                        <label className="form-label" htmlFor="basic-icon-default-email">Select Competencies</label>
                        {selectedUsersLoaded ?
                            <MultiSelectDropdown 
                                optionsList={competencies} 
                                defaultValue={selectedCompetencies} 
                                formik={formik}
                            />: 
                            <>
                            <MultiSelectDropdown 
                                optionsList={competencies} 
                                // defaultValue={selectedCompetencies} 
                                formik={formik}
                            />
                            {formik.touched.competencies && formik.errors.competencies && (
                                <div className="text-danger">{formik.errors.competencies}</div>
                            )}
                            </>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                        <button type="submit" className="btn btn-primary">{type == 'Add' ? 'Add' : 'Update'}</button>
                    </Modal.Footer>
                </form>
        </Modal>
    )
}
export default AddTemplate;
AddTemplate.propTypes = {
    type: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    // handleClose: PropTypes.func.isRequired    
};